import './GifMosculos.css'

const GifMosuclos = () => {
    return (
        <>
            <div className="gifMosculos">
                <img src="/images/MOSCULOS.gif" alt="Mosca Musculosa" />
            </div>
        </>
    );
};

export default GifMosuclos;